<template>
  <div class="period-filter">
    <Dropdown
      :config="{ inputSize: 38, color: 'white', active: false }"
      :values="periods"
      :placeholder="$t('filterByPeriod')"
      :on-change="value => (period = value)"
      :value="period"
    >
      <template #placeholder="{ value, isPlaceholder }">
        <div v-if="!isPlaceholder" class="manager">{{ period.text }}</div>
        <div v-else class="manager grey">{{ value }}</div>
      </template>
      <template #choices="{ choice }">
        <div class="manager white" :class="{ highlight: choice === period }">
          {{ choice.text }}
        </div>
      </template>
    </Dropdown>
  </div>
</template>

<script>
import Dropdown from '@/components/Dropdown';

export default {
  components: { Dropdown },

  props: {
    value: {
      type: Object,
    },
  },

  data() {
    return {
      periods: [
        {
          text: this.$t('lastMonth'),
          from: this.setPeriodStart(30),
        },
        {
          text: this.$t('last6Months'),
          from: this.setPeriodStart(180),
        },
        {
          text: this.$t('last2Years'),
          from: this.setPeriodStart(365 * 2),
        },
      ],
      period: null,
    };
  },

  watch: {
    period(period) {
      this.$emit('input', period);
    },
  },

  mounted() {
    this.period = this.value;
  },

  methods: {
    setPeriodStart(days) {
      if (!days) return 0;
      const date = new Date(new Date().getTime() - 1000 * 3600 * 24 * days);
      this.resetHours(date);
      return date.getTime() || 0;
    },

    resetHours(date) {
      date.setHours(0);
      date.setMinutes(0);
      date.setSeconds(0);
      date.setMilliseconds(0);
    },
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/colors.scss';
@use '@/styles/responsive.scss';
@use '@/styles/fonts.scss';
.period-filter {
  margin-left: auto;
  width: 20%;
  margin-bottom: 24px;

  :deep(.dropdown) {
    margin-bottom: 0;

    .input {
      height: 34px !important;
    }
  }
}
</style>
